import React from "react";
import { ButtonContainerProps } from "./ButtonContainer.types";
import { ButtonContainerBox } from "./ButtonContainer.style";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class ButtonContainer extends Container<
  ButtonContainerProps,
  CoreContainerState
> {
  constructor(props: ButtonContainerProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { id } = this.props;
    const className =
      this.childComponents && this.childComponents.length % 2 === 0
        ? "buttoncontainer__par"
        : "buttoncontainer__impar";

    return (
      <>
        <ButtonContainerBox id={id} className={"buttoncontainer " + className}>
          {this.childComponents && this.childComponents.length > 0 ? (
            <>
              {this.childComponents.length % 2 === 1 ? (
                this.childComponents.map((item, k) =>
                  k < 4 ? <div key={k} className="buttoncontainer__box_impar">{item}</div> : null
                )
              ) : (
                <>
                  {this.childComponents.length === 4 ? (
                    <>
                      <div className="buttoncontainer__box_par">
                        {this.childComponents.slice(0, 2).map((item, k) => (
                          <div key={k}>{item}</div>
                        ))}
                      </div>
                      <div className="buttoncontainer__box_par">
                        {this.childComponents.slice(2, 4).map((item, k) => (
                          <div key={k + 2}>{item}</div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="buttoncontainer__box_par">
                      {this.childComponents.map((item, k) => (
                        <div key={k}>{item}</div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </>
          ) : null}
        </ButtonContainerBox>
        {this.childComponents.length < 4 && this.placeholderComponent}
      </>
    );
  }
}
